import React from 'react'
import cx from 'classnames'
import { Icon } from '@manychat/manyui'

import { SliceType } from 'components/MCTextEditor/slice/types'
import { Decorators } from 'components/RichTextEditor/decorators/useDecorators'

import ToolbarItem from './ToolbarItem'

const SimpleDecoratorTool = ({
  decorators,
  decoratorType,
  className = '',
}: {
  decorators: Decorators
  decoratorType: SliceType
  className?: string
}) => {
  const anchors: Partial<Record<SliceType, React.ReactNode>> = {
    [SliceType.BOLD]: <Icon.Bold size={24} className="d-flex" />,
    [SliceType.ITALIC]: <Icon.Italic size={24} className="d-flex" />,
    [SliceType.UNDERLINE]: (
      <Icon.Underline size={24} className="d-flex" style={{ position: 'relative', top: '1px' }} />
    ),
  }

  const anchor = anchors[decoratorType]
  if (!anchor) {
    return null
  }

  return (
    <ToolbarItem
      isSelected={decorators.isActive(decoratorType)}
      className={className}
      renderAnchor={(isSelected) => (
        <div className={cx('pointer', { ['text-primary']: isSelected })}>{anchor}</div>
      )}
      onClick={() => void decorators.toggle({ type: decoratorType })}
    />
  )
}

export default SimpleDecoratorTool
